<template>
  <div>
    <q-card-section class="text-center text-h6">
      {{ t("pricing.title") }}
    </q-card-section>
    <q-card-section class="text-center text-h3">
      ${{ computedPrice }}
    </q-card-section>
    <q-card-section>
      <q-slider
        v-model="squareFootage"
        color="info"
        :class="{ 'q-mt-md': margin }"
        label
        label-color="accent"
        label-always
        label-text-color="dark"
        :label-value="squareFootage + ' sq.ft.'"
        :min="500"
        :max="7500"
        :step="100"
      />
    </q-card-section>
    <q-card-section class="text-subtitle1" style="line-height: 1.3125">
      {{ t("pricing.description") }}
    </q-card-section>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { i18n } from "src/boot/i18n";
import { isColorDark } from "src/composables/useRandomPalette";
import { useSettingsStore } from "src/stores/settings";

defineOptions({ name: "PricingSlider" });

const props = defineProps({
  margin: { type: Boolean, default: false },
});

const { t } = i18n.global;
const settingsStore = useSettingsStore();
const { computedPrice, selectedPalette, squareFootage } =
  storeToRefs(settingsStore);

const textColor = ref("dark");

const handleTextColor = () => {
  textColor.value = isColorDark(selectedPalette.value.accent?.hex || "#000000")
    ? "white"
    : "dark";
};

watch(
  selectedPalette,
  () => {
    handleTextColor();
  },
  { deep: true }
);

onMounted(() => {
  handleTextColor();
});
</script>
